import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {NotificationDialogComponent} from '@aviary/dialogs/notification-dialog/notification-dialog.component';
import {NotificationDialog, NotificationDialogDefinition} from '@aviary/dialogs/notification-dialog/notification-dialog.types';
import {MAT_DIALOG_DATA, MatDialogConfig} from '@angular/material/dialog';
import {MEDIUM_DIALOG_CONFIG} from '@aviary/dialogs/base-dialog/base-dialog.types';

export interface LibraryCardPolicyDialogData {
  messageHtml: string;
}

@Component({
  selector: 'px-library-card-policy-dialog',
  template: `
    <mx-notification-dialog [definition]="dialogDefinition">
      <div [innerHTML]="cleanedMessageHtml" class="whitespace-pre-line"></div>
    </mx-notification-dialog>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NotificationDialogComponent]
})
export class LibraryCardPolicyDialog implements NotificationDialog<LibraryCardPolicyDialogData> {

  public readonly dialogData: LibraryCardPolicyDialogData = inject(MAT_DIALOG_DATA);
  public readonly cleanedMessageHtml = this.cleanMessageHtml();
  public static readonly dialogConfigOverrides: MatDialogConfig = {...MEDIUM_DIALOG_CONFIG, minHeight: 'auto'};

  public readonly dialogDefinition: NotificationDialogDefinition = {
    title: 'Library Card Policy',
    confirmButtonLabel: 'Close'
  };

  /**
   * Clean/tidy/massage the policy text we get back from the Organization object.  Surely these rules will evolve over time, but for now this covers the
   * special cases we've seen with our existing clients' policies.
   */
  private cleanMessageHtml(): string {
    return this.dialogData.messageHtml
      .replace(/\\n/g, '<br>') // Replace any \n line breaks with <br> so it renders correctly
      .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" '); // Ensure any links open in a new tab so we don't interrupt the patron's
    // registration steps
  }
}
